module.exports = __webpack_public_path__ + "static/img/装2.78fd5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装2.png
// module id = Z2VB
// module chunks = 2